import { trackMainJsExecuted } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/trackMainJsExecuted";
import * as React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { init as initWebApi } from "./initialize/web-api";
import initializeApp from "./initializeApp";

trackMainJsExecuted(); // execute this function before anything else

(async function main() {
  initWebApi();
  await initializeApp();
  const container = document.getElementById("root");
  const root = createRoot(container!);
  root.render(<App />);
})();
